
import { Component, Vue } from "vue-property-decorator";
import { Toast } from "vant";

@Component
export default class errPage extends Vue
{

}
